<ui-form-field-layout
	[isRequired]="isRequired()"
	[title]="title()"
	[subtitle]="subtitle()"
	[isValid]="isValid()"
	[hint]="hint()"
	[suffix]="suffix()"
>
	<div class="ui-input" slot="input">
		<div [libFlexRow]="true" [libFlexRowGap]="'16px'">
			@for (iconType of availableIconTypes(); track iconType) {
			<div libFlexColumn>
				<lib-button
					[buttonType]="iconType === rawValue() ? 'primary' : 'basic'"
					(click)="handleSelectIcon(iconType)"
					[iconOnly]="true"
					[icon]="iconType"
				></lib-button>
			</div>
			}
		</div>
	</div>
</ui-form-field-layout>
